module.exports = __webpack_public_path__ + "assets/0906f709e823be77bea838aa328e99a9.png";